export default function (selector, config) {
  var vueCtrl = new Vue({
    el: selector,
    data: {
        notifications: [],
        recentNotifications: [],
        activeNotification: false
    },
    filters: {
        formatDate: function formatDate(n) {
            var currentUTCDate = new Date()
            var utcDate = new Date(n.created_at);

            var seconds = Math.floor((currentUTCDate - utcDate) / 1000);
            var interval = Math.floor(seconds / 31536000)

            if (interval >= 1) {
                var locText = config.event_strings.time_frames.years_ago_js
                if (interval == 1) {
                    locText = config.event_strings.time_frames.year_ago_js
                }
                return locText.replace("{AMOUNT}", interval);
            }

            interval = Math.floor(seconds / 2592000);
            if (interval >= 1) {
                var locText = config.event_strings.time_frames.months_ago_js
                if (interval == 1) {
                    locText = config.event_strings.time_frames.month_ago_js
                }
                return locText.replace("{AMOUNT}", interval);
            }

            interval = Math.floor(seconds / 86400);
            if (interval >= 1) {
                var locText = config.event_strings.time_frames.days_ago_js
                if (interval == 1) {
                    locText = config.event_strings.time_frames.day_ago_js
                }
                return locText.replace("{AMOUNT}", interval);
            }
            
            interval = Math.floor(seconds / 3600);
            if (interval >= 1) {
                var locText = config.event_strings.time_frames.hours_ago_js
                if (interval == 1) {
                    locText = config.event_strings.time_frames.hour_ago_js
                }
                return locText.replace("{AMOUNT}", interval);
            }

            interval = Math.floor(seconds / 60);
            if (interval >= 1) {
                var locText = config.event_strings.time_frames.minutes_ago_js
                if (interval == 1) {
                    locText = config.event_strings.time_frames.minute_ago_js
                }
                return locText.replace("{AMOUNT}", interval);
            }

            if (Math.floor(seconds) > 1) {
                var locText = config.event_strings.time_frames.seconds_ago_js
                return locText.replace("{AMOUNT}", Math.floor(seconds));
            }

            return config.event_strings.time_frames.just_nowss
        }
      },
      computed: {
          notificationsList: function () {
              var ignoreList = ['createBreakoutRoom', 'realTimeSurvey'];
              var list = this.notifications.filter(function (n) {
                  return !ignoreList.includes(n.notification_type)
              });                    
              
              return list;
          },
          recentNotificationsList: function () {
              var ignoreList = ['createBreakoutRoom', 'realTimeSurvey'];
              var list = this.recentNotifications.filter(function (n) {
                  return !ignoreList.includes(n.notification_type)
              });                    
              
              return list;
          }
      },
      
      methods: {
          markPopupNotificationAsRead: function (notification, index) {
              var i = this.notifications.indexOf(notification);
              if (i != -1) {
                  this.markPopupAsRead(notification, i)
              }

              this.recentNotifications.splice(index, 1);
          },

          closePopupNotification: function (notification, index) {
              var i = this.notifications.indexOf(notification);
              if (i != -1) {
                  $.ajax({
                      type: "PUT",
                      url: '/notifications/' + notification.id,
                      data: {
                      },
                      dataType: "json",
                      success: function(response) {},
                      error: function(response) {}
                  });

                  this.updateNotificationsBadge()
              }

              this.recentNotifications.splice(index, 1);
          },

          inviteRequestText: function(type) {
              return type === 'invitee' ? config.event_strings.agenda.start_video_chat_button : config.event_strings.agenda.join_vmeet_room_button;
          },
          setDateTimeAttrs: function() {
              this.notifications.forEach((n) => {
                  var $notif = $(this.$refs['notif-' + n.id]);
                  var dt = n.timeslots && n.date
                  if (dt) {
                      $notif.find('.requestDate').html(n.date);
                      $notif.find('.requestTime').html(n.timeslots);
                  }
              })
          },
          markAsRead: function(notification, index) {
              $.ajax({
                  type: "PUT",
                  url: '/notifications/' + notification.id,
                  data: {
                      was_read: true
                  },
                  dataType: "json",
                  success: function(response) {},
                  error: function(response) {}
              });

              notification.was_read = true
              this.updateNotificationsBadge()

              if (notification.notification_type === 'createBreakoutRoom') {
                  var attendees = notification.metadata.attendees.filter(function(a) {
                      return a.id != this.eventAttendeeId
                  })

                  var url = notification.metadata.url
                  var message = [
                      '<div>',
                      '<p>', notification.metadata.description, '</p>',
                  ]

                  if (attendees.length > 1) {
                      message = message.concat(['<p>Other invitees:</p>', '<ul>'])
                      attendees.forEach(function(a) {
                          message.push('<li>' + a.name + '</li>')
                      })
                      message = message.concat(['</ul>'])
                  }

                  message = message.concat(['</div>']).join('\n')
                  var heading = notification.message
                  if (notification.admin_id != this.eventAttendeeId) {
                      heading = notification.metadata.sender + ' has invited you to a new meeting room.'
                  }

                  $('#notifications-modal-title').html(heading)
                  $('#notifications-modal-message').html(message)
                  this.activeNotification = notification

                  $('#notifications-modal').modal('show')
              }

              if (notification.notification_type === 'meetingRequestUpdate') {
                  var type = notification.metadata.requestType;
                  if(type !== 'cancel' && type !== 'deny') {
                      window.location = notification.metadata.domain;
                  }
              }

              if (notification.has_plugin) {
                  var url = null;
                  
                  switch(notification.plugin_type) {
                  case "Directory":
                      var url = "/directories/"+notification.plugin_id;
                      break;

                  case "Broadcast":
                      var url = "/broadcasts/"+notification.plugin_id;
                      break;

                  case "EventForm":
                      var url = "/forms/"+notification.plugin_id;
                      break;

                  case "InteractiveMap":
                      var url = "/interactive-maps/"+notification.plugin_id;
                      break;

                  case "Library":
                      var url = notification.plugin_url ? notification.plugin_url : "/libraries/"+notification.plugin_id;
                      break;

                  case "PhotoStream":
                      var url = "/photo-streams/"+notification.plugin_id;
                      break;

                  case "PhotoStreamCamera":
                      break;

                  case "QuestionPlugin":
                      var url = "/questions/"+notification.plugin_id;
                      break;

                  case "MainStage":
                      var url = "/main-stage/"+notification.plugin_id;
                      break;

                  case "Schedule":
                      var url = "/schedule";
                      break;

                  case "ScheduleItemTicket":
                      var url = "/schedule/enroll";
                  break;

                  case "Social":
                      var url = "/social-streams/"+notification.plugin_id;
                  break;

                  case "VideoPagePlugin":
                    var url = "/video-page-plugins/"+notification.plugin_id;

                  default:
                      break;
                  }

                  if (url !== null) {
                      if (url.includes(window.location.hostname)) {
                          window.location = url;
                      } else {
                          window.open(url);
                      }
                  }
              }
          },
          markPopupAsRead: function(notification, index) {
              this.markAsRead(notification.notification, index)

              // Open notification panel for notification with no plugins and 
              // special notifications that have a separate button for redirecting the user
              if (!notification.notification.has_plugin && 
                  notification.notification_type !== 'socialStreamTaggedUser' && 
                  notification.notification_type !== 'inviteToChat') {
                  window.openNotificationPanel()
              }
          },

          updateNotificationsBadge: function() {
              var ignoreList = ['createBreakoutRoom', 'realTimeSurvey'];
              var total = this.notifications.filter(function (n) {
                  return (!ignoreList.includes(n.notification_type) && !n.was_read)
              }).length
              var badgeEl = window.$(".notifications-count-badge");
              if (total > 0) {
                  badgeEl.html(total)
                  badgeEl.css('display', 'block')
              } else {
                  badgeEl.css('display', 'none')
              }
          },

          reloadNotifications: function() {
              var self = this
              $.ajax({
                  type: "GET",
                  url: '/notifications?json',
                  dataType: "json",
                  success: function(response) {
                      self.notifications = response.data.notifications;
                      self.updateNotificationsBadge()
                      self.setDateTimeAttrs();
                  },
                  error: function(response) {}
              });
          },
          notificationModalAction: function() {
              if (this.activeNotification && this.activeNotification.notification_type === 'createBreakoutRoom') {
                  window.location = this.activeNotification.metadata.url
              }
          },
          sendAcceptedInvite: function(data) {
              var chatAcceptedMsg = config.event_strings.settings_modal.chat_request_accepted.replace(":name", data.owner)
              var notificationText = "<p><b>"+chatAcceptedMsg+"</b></p>";

              Http.post('/notifications', {
                userType: 'EventAttendee',
                notificationType: 'inviteToChat',
                notificationText: notificationText,
                sendTo: [String(data.senderId)],
                inviteId: data.inviteId,
                metadata: {'directory': data.directory, 'type': 'requester', 'url': data.url}
              }, function (res) {
                console.log(res)
              }, function (err) {
                console.error(err)
              })

              this.sendAcceptedInviteEmail(data)
          },
          sendAcceptedInviteEmail: function(data) {
              var emailSubject = 'Your video chat request has been accepted'
              data.inviteRequest = true;
              data.acceptedInvite = true;

              var email  = {
                  'name': data.owner,
                  'from': null, //
                  'to': null, //
                  'subject': emailSubject,
                  'sendTo': data.senderId,
                  'meetingRequest': data
              }

              Http.post('/directory-schedule/email', {'email': email});
          },
          joinInviteRequest: function(notification) {
              var metadata = notification.metadata

              // Send invite notification to requester
              if(metadata.type === 'invitee' && !metadata.status) {
                  metadata.status = 'accepted';
                  Http.put('/notifications/' + notification.id, {metadata: metadata});
                  this.sendAcceptedInvite(metadata);
              }
              // Open chat room
              window.open(metadata.url, '_blank');
          },
          goToPost: function(notification) {
              var metadata = notification.metadata
              if (metadata != null) {
                  window.open(metadata.url);
              }
          },
          getLocNotificationMessage(notification, fields) {
              var message = notification.message
              var locMessage = null
              if (notification.globalize) {
                  var globalization = JSON.parse(notification.globalize_json)
                  var loc = globalization.find(g => g.language == fields.language)
                  locMessage = loc == undefined || loc == null ? message : loc.value
              }
              
              return locMessage == null ? message : locMessage
          }
      }
  })
  return vueCtrl
}